import { useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';

import WineFact from './WineFact.presentational';
import styles from './wineFacts.scss';

const TRANSLATIONS = {
  facts: 'components.shared.wine_summary.facts',
};

const WineFacts = ({ facts = [] }) => {
  const { t } = useI18N();
  // There should always be fact about sulfites in allergen fact
  // so this shouldn't happen, but keeping this check
  // so that it works even if we change the policy about sulfites fact
  if (facts.length === 0) {
    return null;
  }

  return (
    <table className={styles.wineFacts}>
      <caption className={styles.headline}>{t(TRANSLATIONS.facts)}</caption>
      <tbody>
        {facts.map((fact) => {
          return <WineFact {...fact} />;
        })}
      </tbody>
    </table>
  );
};

WineFacts.propTypes = {
  facts: PropTypes.array.isRequired,
};

export default WineFacts;
